import { useAuth } from "@/context/AuthContext";
import { Navigate, useLocation } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-muted">
        <div className="text-muted-foreground text-sm">Yükleniyor...</div>
      </div>
    );
  }
  if (!user) {
    // Tur 2.5C: kullanıcı bir bildirim / deep link'ten geldiyse yolu koru,
    // login sonrası buraya döndürelim.
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }
  return children;
}
